module.exports = __webpack_public_path__ + "img/event-owner-badge.c9d52072.svg";